import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { TaskMessage } from 'src/app/models/message/task-message.model';
import { ConditionsTask } from 'src/app/models/task/conditons-task.model';
import { User } from 'src/app/models/user/user.model';
import { MessageService } from 'src/app/services/message.service';
import { TaskService } from 'src/app/services/task.service';
import { FileService } from 'src/app/services/file.service';
import { TrackingInfo } from 'src/app/models/tracking-info.model';
import { DocsService } from 'src/app/modules/loan-docs/services/docs.service';
import Swal from 'sweetalert2';
import { Utils } from 'src/app/core/services/utils';
import { DateTime } from 'luxon';

@Component({
    selector: 'conditions-task-information-dialog',
    templateUrl: './conditions-task-information-dialog.component.html',
    styleUrls: ['./conditions-task-information-dialog.component.scss'],
    standalone: false
})
export class ConditionsTaskInformationDialogComponent implements OnInit {

  task: ConditionsTask;

  listInternalNotes: Array<TaskMessage> = [];

  listBorrowerNotes: Array<TaskMessage> = [];

  users: User[];

  historyVisible: boolean = false;

  taskTrackingInfo: TrackingInfo[];

  columns: any[];

  uploadedFiles: Array<File> = [];

  autoTransition: boolean = true;

  autoConvertToPdf: boolean = false;

  useDynamicCompression: boolean = true;

  constructor(public activeModal: NgbActiveModal,
    private readonly _taskService: TaskService,
    private readonly _messageService: MessageService,
    private readonly _docsService: DocsService,
    private readonly _fileService: FileService) { }

  ngOnInit(): void {
    this.columns = [
      { field: 'actionValue', header: 'Action' },
      { field: 'dateCreated', header: 'Date Created' },
      { field: 'by', header: 'By' },
    ];
    this._messageService.getInternalTaskMessages(this.task.loanDocTaskId).subscribe((response) => {
      this.listInternalNotes = response;
    });
    this._messageService.getBorrowerTaskMessage(this.task.loanDocTaskId).subscribe((response) => {
      this.listBorrowerNotes = response;
    });
  }

  onOkClicked = () => {
    this.saveTask();
  }

  onCancelClicked = () => {
    this.activeModal.dismiss();
  }

  toggleTaskView = () => {
    this.historyVisible = !this.historyVisible;
    if (this.historyVisible && !this.taskTrackingInfo) {

      this._taskService.getTaskTracking(this.task.loanDocTaskId).subscribe((response) => {
        this.taskTrackingInfo = response;
      }, (err) => {

      });
    }
  }

  onFileUploadChanged = (e: File[]) => {
    if (!e || e.length === 0) return;

    const maxSupportedFileSize = 134217728;
    const oversizedFiles = e.filter(file => file.size > maxSupportedFileSize);
    const validFiles = e.filter(file => file.size <= maxSupportedFileSize);

    if (oversizedFiles.length > 0) {
      const fileNames = oversizedFiles
        .map(file => `• ${file.name} (${Utils.formatBytes(file.size)})`)
        .join('<br>');

      Swal.fire({
        icon: 'warning',
        title: 'File(s) Too Large',
        html: `The following file(s) exceed the ${Utils.formatBytes(maxSupportedFileSize)} limit and will not be uploaded:<br><br>${fileNames}`,
        confirmButtonText: 'OK',
      }).then(() => {
        if (validFiles.length > 0) {
          this.uploadedFiles = validFiles;
        } else {
          this.uploadedFiles = [];
        }
      });
    } else {
      this.uploadedFiles = validFiles;
    }
  }

  saveTask = () => {
    let docFiles = [];
    this.uploadedFiles.forEach(file => {
      docFiles.push({
        guid: null,
        file: file,
        fileName: file.name,
        note: "",
        borrowerNote: "",
        active: true
      });
    });
    if (!this.task.docFiles) {
      this.task.docFiles = [];
    }
    this.task.docFiles = this.task.docFiles.concat(docFiles);

    const data = {
      loanDocTask: this.task,
      multipleBorrower: null,
      numFiles: this.task.docFiles.length,
      daysToPostpone: 0
    }
    // Only move the task into a completed/blocking status AFTER its files upload (LLS-119).
    this._taskService.saveTaskWithFileOps(data, (taskId) => this.buildTaskFileOperations(taskId)).subscribe((responseTask) => {
      this.activeModal.close(this.task);
    }, (err) => {
      this.activeModal.dismiss();
    })
  }

  private buildTaskFileOperations = (taskId: number): Observable<any>[] => {
    const promises: Observable<any>[] = [];
    this.task.docFiles.forEach(file => {
      if (file.guid == null) {
        promises.push(this._docsService.uploadFileForTask(file.file, taskId, this.autoTransition, this.autoConvertToPdf, this.useDynamicCompression))
      }
      else if (file.guid != null && file.active == false) {
        promises.push(this._fileService.removeFile(file.guid));
      }

    });
    return promises;
  }

}
